import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../../assets/Icons";
import SecondaryButton from "../../../../../components/_utils/CommonButtons/SecondaryButton";
import CommonToast from "../../../../../components/_utils/CommonToast";
import ApprovalTopNavComponent from "../../../../../components/_utils/CommonTopNav/ApprovalTopNav";
import CardContainer from "../../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TickerAnimation from "../../../../../components/_utils/TickerAnimation";
import BeneTxnDeclinePopup from "../../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/BeneTxnDeclinePopup";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";
import Loader from "../../../../../components/Loader/Index";
import BeneficiaryTransactionDetailsPopup from "../../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionDetailsPopup/index.jsx";
import {
  getCreateTransactionBalance,
  resetOwnerBalance,
} from "../../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  beneficiaryTransactionsApprove,
  resetBeneTransactionsApproval,
} from "../../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import formatDateViewAll from "../../../../../utils/formatDateViewAll";
import UseHandleScroll from "../../../../../hooks/useHandleScroll";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import PrimaryButton from "../../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";

const BeneficiaryMultiApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const conditionVarLengthZero = 0;
  const [txnId, setTxnId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refreshId, setRefreshId] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [PrevBalance, setPrevBalance] = useState(null);
  const [failedRefreshId, setFailedRefreshId] = useState([]);
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [isApprovalError, setIsApprovalError] = useState(false);
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [transactionFilterID, setTransactionFilterID] = useState([]);
  const [transactionFilterData, setTransactionFilterData] = useState([]);

  const [direction, setDirection] = useState("");
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.beneTxnMultiApprCardHeight,
  );

  const { showReloginModal } = useSelector((state) => state.login);
  const services = useSelector((state) => state.refreshToken.services);

  const handleRefresh = (e, id, txnId, prevBalance) => {
    if (services?.includes("VAccountBalance") || services?.includes("Admin")) {
      e.stopPropagation();
      setPrevBalance(prevBalance);
      setrefreshAnimation(txnId);
      setRefreshId(txnId);
      setFailedRefreshId((prev) =>
        prev.filter((failedId) => failedId !== txnId),
      );

      dispatch(getCreateTransactionBalance(id));
    } else {
      e.stopPropagation();
      navigate("/feature_not_assigned");
    }
  };

  const checkService =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      setTransactionFilterData(
        storedSelectedApproval?.selectedSendTransactions,
      );
      setTransactionFilterID(storedSelectedApproval.selectedTransactions);
    } else {
      setTransactionFilterData([]);
      setTransactionFilterID([]);
    }
  }, []);
  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };
  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };

  const {
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    createTransactionBankRefreshData,
  } = useSelector((state) => state.ownerAllVerification);

  useEffect(() => {
    if (createTransactionBankRefreshLoading) {
      toast.dismiss();
      setTimeout(() => {
        UniversalRefreshToast();
      }, 200);
    } else if (createTransactionBankRefreshData?.status) {
      toast.dismiss();
      setTimeout(() => {
        CommonToast({
          text: "Balance refreshed successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, 500);
      if (refreshAnimation) {
        setFailedRefreshId((prev) =>
          prev.filter((failedId) => failedId !== refreshAnimation),
        );
      }
    } else if (
      createTransactionBankRefreshError &&
      !createTransactionBankRefreshLoading
    ) {
      toast.dismiss();
      setTimeout(() => {
        CommonToast({
          text: createTransactionBankRefreshError,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      }, 100);
      if (refreshAnimation) {
        setFailedRefreshId((prev) => [...prev, refreshAnimation]);
      }
    }
    if (createTransactionBankRefreshData) {
      setTransactionFilterData((prev) => {
        const updated = prev.map((val) => {
          if (
            val.owner_account_id ===
            createTransactionBankRefreshData?.owner_accounts[0]
              ?.owner_account_id
          ) {
            return {
              ...val,
              owner_account_balance:
                createTransactionBankRefreshData?.owner_accounts[0]
                  ?.owner_account_balance,
              owner_account_balance_last_fetched_at_in_words:
                createTransactionBankRefreshData?.owner_accounts[0]
                  ?.owner_account_balance_last_fetched_at_in_words,
            };
          }
          return val;
        });

        const selectedData = {
          selectedSendTransactions: updated,
          selectedTransactions: transactionFilterID,
        };

        sessionStorage.setItem("selectedData", JSON.stringify(selectedData));
        return updated;
      });
    }
    return () => {
      dispatch(resetOwnerBalance());
    };
  }, [
    createTransactionBankRefreshData,
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    dispatch,
    transactionFilterID,
    refreshAnimation,
  ]);

  let total = transactionFilterData?.reduce(
    (acc, { amount }) => acc + Number(amount || 0),
    0,
  );

  const handleOpenPopup = (id) => {
    setShowPopup(true);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const updateAllAccounts = (updatedAccounts) => {};

  const handleTxnApproval = async (id) => {
    setLoading(true);
    UniversalRefreshToast("Approving transaction");

    if (transactionFilterID?.length) {
      dispatch(resetBeneTransactionsApproval());
      const data = await dispatch(beneficiaryTransactionsApprove({ id }));

      setTimeout(() => {
        setLoading(false);
        toast.dismiss();
        if (data?.payload?.status === 500) {
          setTimeout(() => {
            CommonToast({
              text: data?.payload?.error,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }, 1000);
        }
        if (data?.payload?.errors?.user_unauthorized?.[0]) {
          setTimeout(() => {
            navigate("/feature_not_assigned", {
              state: {
                unavailableService: "VBeneficiaryTxn",
              },
            });
          }, 1000);
        } else if (data?.payload?.status === true) {
          const selectedData = {
            selectedSendTransactions: data?.payload?.transactions,
            selectedTransactions: transactionFilterID,
          };

          sessionStorage.setItem("selectedData", JSON.stringify(selectedData));
          navigate(
            "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval/success",
          );
        } else if (data?.payload?.status === false) {
          setIsApprovalError(true);
        }
      }, 2000);
    }
  };

  useEffect(() => {
    if (isApprovalError && showReloginModal === false) {
      navigate(
        "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval/error",
        {
          state: { type: "recreate_Multi" },
          replace: true,
        },
      );
    }
  }, [navigate, showReloginModal, isApprovalError]);

  const isNoTransactionSelected =
    transactionFilterData.length === conditionVarLengthZero;

  return (
    <>
      {showTxnDetailPop ? (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneTxnDetailModal();
          }}
        >
          <BeneficiaryTransactionDetailsPopup
            closeBeneTxnDetailModal={closeBeneTxnDetailModal}
            bene_txn_id={txnId}
            setTransactionFilterData={setTransactionFilterData}
            setTransactionFilterID={setTransactionFilterID}
            type={"bene_txn_detail_modal"}
            typeSingle={"Additional_Details"}
            typeMulti={"MultiApproval_Session_Data"}
          />
        </div>
      ) : null}
      {showPopup ? (
        <BeneTxnDeclinePopup
          handleClose={handleClosePopup}
          txnId={transactionFilterID}
          allTxnData={transactionFilterData}
          updateAllTxn={updateAllAccounts}
          flow="multiApproval"
        />
      ) : null}

      <div
        className="int-txn-mutli-details-main"
        style={{
          overflow: showPopup ? "hidden" : "",
          height: showPopup ? "var(--full-height)" : "",
        }}
      >
        {loading ? (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <div className="flex justify-center items-center">
              <Loader />
            </div>
          </div>
        ) : null}
        <div className="hidden Qmd:block min-h-[var(--navbar-breadcrumb-height)] h-navbar-breadcrumb-height bg-primary-nav"></div>
        <div className="int-txn-mutli-container z-z-index-overlay">
          <ApprovalTopNavComponent
            direction={direction}
            handleBack={() => navigate(-1)}
            topNavCtaBtn1Needed={false}
            topNavHeader={total}
            topNavSubText="Total amount"
            topNavCtaBtn1Props={{
              btnText: "Previous",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => navigate(-1),
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              hoverOption: "white",
            }}
            topNavCtaBtn2Needed={false}
            topNavCtaBtnWithIcon1Props={{
              btnText: "Reject",
              handleFunction: () => {
                if (!isNoTransactionSelected) {
                  handleOpenPopup(transactionFilterID);
                }
              },
              enabledBgColor: "var(--failed)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              iconToBeAlign: "right",
              isDisabled: isNoTransactionSelected,
            }}
            topNavCtaBtnWithIcon2Props={{
              btnText: "Approve",
              handleFunction: () => {
                if (!isNoTransactionSelected) {
                  handleTxnApproval(transactionFilterID);
                }
              },
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
              iconToBeAlign: "right",
              isDisabled: isNoTransactionSelected,
            }}
            BottomHeader={`Post Approval Process`}
            BottomSubText={`Once approved, transaction distribution will get created and auto settled using selected source account. If there are insufficient funds, the transaction will settle once the source account is refilled, and distribution will be initiated thereafter.`}
            isToggleNeeded={false}
            selectionBtnProps={{
              btnText: "View selected",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => {},
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              icon: ICONS?.RELOAD_REFRESH_WHITE,
            }}
            iconComponentArray={[
              {
                enabledBgColor: "var(--primary-bg)",
                isLoading: loading,
                handleFunction: () => {},
                isDisabled: false,
                icon: ICONS?.RELOAD_REFRESH_WHITE,
                title: "Refresh schedules",
                hoverOption: "white",
              },
            ]}
            assignLabelNeeded={false}
            assignTagNeeded={false}
          />
        </div>
        <div
          className="h-full overflow-y-scroll relative Qmd:mb-margin-base mb-[var(--topnav-bottom-height)]"
          onScroll={handleScroll}
        >
          {transactionFilterData?.length !==
            GlobalConfiguration.lengthCheckZero && (
            <>
              <h4 className="w-width-almost-full text-left text-font-md font-semibold text-text-primary mt-margin-md mx-auto whitespace-nowrap">
                Selected Transaction ({transactionFilterData?.length})
              </h4>
            </>
          )}

          <div
            className={`${
              transactionFilterData?.length !==
              GlobalConfiguration.lengthCheckZero
                ? "standard-card-alignment"
                : "h-full"
            } gap-gap-md`}
          >
            {transactionFilterData?.length ===
            GlobalConfiguration.lengthCheckZero ? (
              <>
                <div className=" flex flex-col justify-center h-full items-center m-auto">
                  <div className=" flex flex-col items-center justify-end">
                    <img
                      src={ICONS?.NO_PENDING_TRANSACTION}
                      alt="No accounts found"
                      className={
                        "w-graphic-width-md h-graphic-square-height-md"
                      }
                    />
                  </div>

                  <div className=" flex flex-col items-center text-center text-font-sm font-normal mt-margin-sm text-text-primary">
                    <p>
                      There are no more transactions that require your approval.
                    </p>
                  </div>
                  <div className=" mt-margin-sm">
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Go to approval"
                      btnType="button"
                      handleFunction={() =>
                        navigate(
                          "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval",
                        )
                      }
                      enabledTextColor="var(--text-primary)"
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                {transactionFilterData?.map((val, i) => {
                  return (
                    <div className="">
                      <CardContainer
                        isDisabled={false}
                        key={val?.txn_id}
                        isSelected={false}
                        isNoCursorRequired={true}
                        isNoHoverRequired={true}
                        onClickHandler={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <card-body>
                          <TextWithIcon
                            type={
                              val.beneficiary_account_approval_status ===
                              "pending"
                                ? "Text"
                                : "Amount"
                            }
                            fontWeight={"semibold"}
                            text={
                              val.beneficiary_account_approval_status ===
                              "pending"
                                ? "Account approval pending"
                                : val?.amount
                            }
                            textColor={"var(--settled)"}
                            subText={
                              val.beneficiary_account_approval_status ===
                              "pending"
                                ? "Account status"
                                : "Amount"
                            }
                            iconComponentArray={
                              val.beneficiary_account_approval_status !==
                              "pending"
                                ? [
                                    ...(val?.confidential_transaction === "Y"
                                      ? [
                                          {
                                            icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                            title: "confidential",
                                            isDisabled: false,
                                          },
                                        ]
                                      : []),
                                  ]
                                : []
                            }
                          />
                          <TextWithIcon
                            type={"Text"}
                            fontWeight={
                              val.beneficiary_account_approval_status ===
                              "pending"
                                ? "var(--font-normal)"
                                : "var(--font-semibold)"
                            }
                            text={val.beneficiary_account_name}
                            textColor={"var(--text-primary)"}
                            subText="Beneficiary name"
                          />
                          <div className="relative">
                            <div className=" flex flex-col gap-y-gap-xs pb-padding-button-l border-b-border mx-mobile-margin-l Qsmd:mx-margin-sm border-primary-bg">
                              <p className="text-font-sm text-text-primary w-full truncate font-normal">
                                {
                                  <TickerAnimation
                                    text={
                                      val.created_on
                                        ? formatDateViewAll(
                                            val.created_on,
                                            false,
                                            false,
                                          )
                                        : "Not given"
                                    }
                                  />
                                }
                              </p>
                              <div className="w-full flex justify-between items-center">
                                <p className="text-font-xs w-width-md text-text-secondary transform-none font-normal">
                                  Date
                                </p>
                                <div className="z-z-index-overlay absolute right-right-base bottom-px">
                                  <SecondaryButton
                                    btnText={
                                      val.beneficiary_account_approval_status ===
                                      "pending"
                                        ? "Approve account"
                                        : "Additional details"
                                    }
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      openBeneTxnDetailModal();
                                      setTxnId(val.txn_id);
                                    }}
                                    isDisabled={false}
                                    enabledBgColor={"var(--text-primary)"}
                                    enabledTextColor={"var(--primary-bg)"}
                                    icon={ICONS?.ARROW_RIGHT_WHITE}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <TextWithBank
                            text={val.owner_account_bank_acc_no}
                            type={"AccountNumber"}
                            subText={"Source account"}
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                            ifscCode={val?.owner_account_ifsc_code}
                          />

                          <TextWithIcon
                            type="Amount"
                            fontWeight={
                              Number(val?.owner_account_balance)
                                ? Number(val?.owner_account_balance) >=
                                  Number(val?.amount)
                                  ? "semibold"
                                  : "semibold"
                                : "normal"
                            }
                            text={
                              val?.owner_account_balance
                                ? val?.owner_account_balance
                                : "Not available"
                            }
                            subText={"Balance"}
                            textColor={
                              val?.owner_account_balance !== null &&
                              val?.owner_account_balance !== undefined
                                ? val?.owner_account_balance === "xxxx.xx" ||
                                  Number.isNaN(
                                    Number(val?.owner_account_balance),
                                  ) ||
                                  Number(val?.owner_account_balance) >=
                                    Number(val?.amount)
                                  ? "var(--settled)"
                                  : "var(--failed)"
                                : "var(--text-primary)"
                            }
                            iconComponentArray={[
                              ...(function () {
                                let iconUrl = "";
                                let titleText = "";

                                if (
                                  createTransactionBankRefreshLoading &&
                                  refreshId === val?.txn_id
                                ) {
                                  iconUrl = ICONS?.LOADER_GIF;
                                  titleText = "Balance updating";
                                } else if (
                                  failedRefreshId.includes(val?.txn_id)
                                ) {
                                  iconUrl = ICONS?.ERROR_WITH_ORANGE_CIRCLE;
                                  titleText = "Balance fetch failed";
                                } else if (
                                  !createTransactionBankRefreshLoading &&
                                  refreshId === val?.txn_id &&
                                  refreshAnimation === val?.txn_id &&
                                  PrevBalance !== undefined &&
                                  Number(val?.owner_account_balance) !==
                                    Number(PrevBalance)
                                ) {
                                  if (
                                    Number(val?.owner_account_balance) >
                                    Number(PrevBalance)
                                  ) {
                                    iconUrl = ICONS?.ARROW_UP_GREEN_GIF;
                                    titleText = "Balance updated";
                                  } else if (
                                    Number(val?.owner_account_balance) <
                                    Number(PrevBalance)
                                  ) {
                                    iconUrl = ICONS?.ARROW_DOWN_RED_GIF;
                                    titleText = "Balance updated";
                                  }
                                }

                                return iconUrl
                                  ? [
                                      {
                                        icon: iconUrl,
                                        title: titleText,
                                        isDisabled: false,
                                      },
                                    ]
                                  : [];
                              })(),
                              ...(() => {
                                if (checkService)
                                  return [
                                    {
                                      icon: ICONS?.RELOAD_REFRESH_WHITE,
                                      title: "Refresh balance",
                                      isDisabled: !(
                                        services?.includes("VAccountBalance") ||
                                        services?.includes("Admin")
                                      ),
                                      onClick: (e) => {
                                        if (
                                          !createTransactionBankRefreshLoading ||
                                          refreshId !== val?.txn_id
                                        ) {
                                          if (
                                            services?.includes(
                                              "VAccountBalance",
                                            ) ||
                                            services?.includes("Admin")
                                          ) {
                                            handleRefresh(
                                              e,
                                              val?.owner_account_id,
                                              val?.txn_id,
                                              val?.owner_account_balance,
                                            );
                                          } else {
                                            e.stopPropagation();
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService:
                                                  "VAccountBalance,Admin",
                                              },
                                            });
                                          }
                                        } else {
                                          e.stopPropagation();
                                        }
                                      },
                                      bgColor: "var(--primary-nav)",
                                    },
                                  ];
                                return [];
                              })(),
                            ]}
                          />
                          <TextWithIcon
                            text={
                              val?.labels?.join(", ") || "No labels assigned"
                            }
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                            iconComponentArray={[
                              {
                                icon: ICONS?.LABEL,
                              },
                            ]}
                          />
                        </card-body>
                      </CardContainer>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BeneficiaryMultiApproval;
